import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { CardSection } from '../CardSection';
import { DateTimeFormat } from '../../Format/DateTimeFormat';
import { CreditReasons } from '../../Credit/CreditReasons';
import { AmountFormat } from '../../Format/AmountFormat';
import OverviewCard from './OverviewCard';
import { CreditStatusChip } from './CreditStatusChip';

const CreditCard = ({ credit }) => {
  const { t } = useTranslation();
  const cardLayout = { size: 'l', contentAlign: 'right' };
  return (
    <OverviewCard header={t('components.cards.credit.credit')}>
      {credit && (
        <Grid container>
          <CardSection title={t('components.cards.credit.status')} {...cardLayout}>
            <CreditStatusChip status={credit.decision} />
          </CardSection>
          <CardSection title={t('enums.creditRating.name')} {...cardLayout}>
            {t(`enums.creditRating.values.${credit.rating}`, credit.rating)}
          </CardSection>
          <CreditReasons credit={credit} layout={{ card: cardLayout }} />
          <CardSection title={t('components.cards.credit.limit')} {...cardLayout}>
            {credit.creditLimitAmount && (
              <AmountFormat amount={credit.creditLimitAmount} currencyCode={credit.currencyCode} fractionDigits="0" />
            )}
          </CardSection>
          <CardSection title={t('components.cards.credit.date')} {...cardLayout}>
            {credit && <DateTimeFormat dateTime={credit.createdDate} />}
          </CardSection>
        </Grid>
      )}
    </OverviewCard>
  );
};

CreditCard.propTypes = {
  credit: PropTypes.shape({
    rating: PropTypes.string,
    creditLimitAmount: PropTypes.number.isRequired,
    currencyCode: PropTypes.string.isRequired,
    decision: PropTypes.string,
    createdDate: PropTypes.string.isRequired,
    reasons: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        reason: PropTypes.string,
      }),
    ),
  }),
};

export default CreditCard;
